import fetch from '@/util/http'

export default {
  myAwardPage(params) {
    return fetch.get('lottery-result/myResult', params)
  },
  myAwardGet(params) {
    return fetch.get('lottery-result/myResultDetail', params)
  },
  myAwardCheck(params) {
    return fetch.post('lottery-result/check', params)
  },
}



// WEBPACK FOOTER //
// ./src/api/award.js